(() => {
  const grid = document.getElementById("product-grid");
  const sentinel = document.getElementById("scroll-sentinel");
  if (!grid || !sentinel) return;

  const sectionId = grid.closest("[data-section-id]")?.dataset.sectionId;
  let currentPage = parseInt(grid.dataset.page);
  const totalPages = parseInt(grid.dataset.totalPages);
  let loading = false;

  if (currentPage >= totalPages) {
    sentinel.remove();
    return;
  }

  const observer = new IntersectionObserver(
    async (entries) => {
      if (!entries[0].isIntersecting || loading) return;
      loading = true;
      currentPage++;

      try {
        const url = `${window.location.pathname}?page=${currentPage}&section_id=${sectionId}`;
        const res = await fetch(url);
        const html = await res.text();
        const doc = new DOMParser().parseFromString(html, "text/html");
        const newItems = doc.querySelectorAll("#product-grid > div");
        const firstSoldOut = grid.querySelector('[data-available="false"]');
        newItems.forEach((item) => {
          if (item.dataset.available === "false") {
            grid.appendChild(item);
          } else {
            grid.insertBefore(item, firstSoldOut || null);
          }
        });
      } catch (e) {
        console.error("Infinite scroll fetch failed:", e);
      }

      if (currentPage >= totalPages) {
        sentinel.remove();
        observer.disconnect();
      }

      loading = false;
    },
    { rootMargin: "100px" },
  );

  observer.observe(sentinel);
})();
